import Vue from "vue";
import { newLogger } from "../../../utils/util";
import network from "../../../utils/network";

let logger = newLogger("MyTodoStore");

const urls = {
  count: "/credit/my-todo/count",
  actives: "/credit/my-todo/actives",
  previouses: "/credit/my-todo/previouses",
};

const initState = () => {
  return {
    count: 0,
    actives: [],
    previouses: [],
  };
};

const actions = {
  fetchCount: async ({ commit }) => {
    try {
      let axios = await network.connection();
      let { data } = await axios.get(urls.count);
      commit("saveCount", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchActives: async ({ commit }) => {
    try {
      let axios = await network.connection();
      let { data } = await axios.get(urls.actives);
      commit("saveActives", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchPreviouses: async ({ commit }) => {
    try {
      let axios = await network.connection();
      let { data } = await axios.get(urls.previouses);
      commit("savePreviouses", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  clear: async ({ commit }) => {
    commit("clear");
  },
};

const mutations = {
  saveCount: (state, count) => {
    Vue.set(state, "count", count);
  },
  saveActives: (state, actives) => {
    Vue.set(state, "actives", actives);
  },
  savePreviouses: (state, previouses) => {
    Vue.set(state, "previouses", previouses);
  },
  clear: (state) => {
    Vue.set(state, "count", 0);
  },
};

const getters = {
  getCount: (state) => {
    return state.count;
  },
  getActives: (state) => {
    return state.actives;
  },
  getPreviouses: (state) => {
    return state.previouses;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations,
  actions,
  getters,
};
